export enum App {
  Core = "sso-core",
  Account = "account-settings",
  Admin = "sso-admin",
}
